<template>
    <div>
        <ul class="rightSible">
            <li class="phone">
                <div>
                    <img src="~assets/image/sideNav/call.png" alt />
                </div>
                <p>电话咨询</p>
                <div class="up">
                    <p>总部 座机 0755-89589212</p>
                    <p v-for="(server, index) in customerServers" :key="index">{{server.areaName}} {{server.title}} {{server.phoneNumber}}</p>
                </div>
            </li>

            <li class="tencent">
                <div>
                    <img src="~assets/image/sideNav/icon-gzh.png" alt />
                </div>
                <p>公众号</p>
                <div class="tentItem">
                    <div>
                        <img src="~assets/image/sideNav/wxgzh.png" alt />
                    </div>
                    <p>官方公众号</p>
                    <div>
                        <img src="~assets/image/sideNav/plt-wx.png" alt />
                    </div>
                    <p>普家公众号</p>
                </div>
            </li>
            <li class="applet">
                <div>
                    <img src="~assets/image/sideNav/icon-xcx1.png" alt />
                </div>
                <p>小程序</p>
                <div class="tentItem">
                    <div>
                        <img src="~assets/image/sideNav/wx-xcx.jpg" alt />
                    </div>
                    <p>普托e享</p>
                    <p>小程序</p>
                </div>
            </li>
            <li :class="['arrowTop',topShow?'topShow':'']" @click="onTop">
                <Icon type="md-arrow-up" />
                <p>TOP</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            topShow: false,
            customerServers: [],
        }
    },
    mounted() {
        window.addEventListener('scroll', this.watchScroll, true);
        this.queryCustomerServers();
    },
    methods: {
        watchScroll() {
            let scrollTop = document.documentElement.scrollTop || window.scrollY || document.body.scrollTop;
            scrollTop > 100 ? this.topShow = true : this.topShow = false;
        },
        queryCustomerServers() {
            
            let customerServers = sessionStorage.getItem("customerServers");

            if(customerServers) {
                this.customerServers = JSON.parse(customerServers);
                return;
            }

            let param = {
                url: 'http://MID-CLIENT-MALL/messageService/websiteService/queryValidCustomerServices',
                body: {}
            }
            this.invoke(param).then(rs => {
                this.customerServers = rs;
                sessionStorage.setItem("customerServers", JSON.stringify(rs));
            })
        },
        // 回到顶部
        onTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 300;
                if (top <= 0) {
                    clearInterval(timeTop);
                }
            }, 10);
        }
    }

}
</script>

<style lang="scss" scoped>
@mixin center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.public {
    background: #ff9000;
    color: #fff;
    text-align: center;
    position: absolute;
    display: none;
}
.tentItem {
    width: 100px;
    padding: 8.5px 0;
    @extend .public;
    right: 70px;
    top: -100px;
    div {
        margin: 5px 0 0 11px;
        width: 80px;
        img {
            width: 80px;
        }
    }
}
.rightSible {
    position: fixed;
    top: 35%;
    right: 0;
    z-index: 99;

    li {
        width: 70px;
        height: 70px;
        background: #646577;
        border-bottom: 1px solid #ebebeb;
        color: #fff;
        @include center;

        &:hover {
            background: #ff9000;
            cursor: pointer;
        }
    }
    li:last-child {
        border-bottom-color: #ebebeb;
    }
    .phone,
    .qq,
    .tencent,
    .applet {
        position: relative;
    }
    .phone {
        width: 70px;
        &:hover .up {
            display: block;
            transition: all 0.8s;
        }
        .up {
            width: 200px;
            @extend .public;
            right: 70px;
            top: 0;
            padding-bottom: 20px;
            p {
                padding-top: 5px;
            }
        }
    }
    .qq {
        &:hover .service {
            display: block;
        }
        .service {
            @extend .public;
            width: 100px;
            height: 69px;
            line-height: 70px;
            right: 70px;
            top: 0;
        }
    }
    // 公众号
    .tencent {
        &:hover .tentItem {
            display: block;
        }
        .tentItem {
            @extend .tentItem;
        }
    }
    // 小程序
    .applet {
        &:hover .tentItem {
            display: block;
        }
        .tentItem {
            @extend .tentItem;
            top: -78px;
        }
    }
    // 回顶部
    .arrowTop {
        @include center;
        display: none;
        font-size: 24px;
        p {
            font-size: 14px;
        }
    }
    .topShow {
        display: block;
        @include center;
    }
}
</style>